import { TListResponse } from 'src/common/types';
import { TTableSort, TTableSortCols } from 'src/components/table/thead/col';


export const BrandListSourceSortCol = {
	ID: 'id',
	NAME: 'name',
	UPDATED_AT: 'updated_at',
	CREATED_AT: 'created_at',
};

export type TBrandListSourceSortCol = TTableSortCols<typeof BrandListSourceSortCol>;

export type TBrandSourceQuery = {
	limit: number;
	offset: number;
	search?: string;
	sort?: TTableSort;
	sortCol?: TBrandListSourceSortCol;
};

export type TBrandListSourceQueryRequest = {
	limit?: number;
	offset?: number;
	search?: string;
	sort?: string;
	sort_col?: string;
};

export function adaptBrandListSourceQueryToRequest(data?: TBrandSourceQuery): TBrandListSourceQueryRequest {
	if (!data) {
		return {};
	}

	const {
		sortCol,
		...restFields
	} = data;

	return {
		sort_col: sortCol,
		...restFields
	};
}

export type TBrandSource = {
  id: number;
  name: string;
};

export type TBrandSourceResponse = TBrandSource;

export type TBrandSourceListResponse = TListResponse<TBrandSourceResponse>;

export type TBrandSourceList = TListResponse<TBrandSource>;

export function adaptBrandSourceFromListResponse(data: TBrandSourceListResponse): TBrandSourceList {
	const {
		items: itemsRaw = [],
		...restFields
	} = data;

	const items = itemsRaw.map(item => adaptBrandSourceFromResponse(item));

	return {
		items,
		...restFields
	};
}

export function adaptBrandSourceFromResponse(data: TBrandSourceResponse): TBrandSource {
	const {
		id,
		name,
	} = data;

	return {
		id,
		name,
	};
}
